import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotificacaoService {
  private readonly path = 'profissionais';

  constructor(private apiService: ApiService) {}

  add(data: any): Observable<any> {
    return this.apiService.post(
      `${this.path}/AddNotificacao`,
      data,
      {},
      true
    );
  }
  addEmail(data: any): Observable<any> {
    return this.apiService.post(
      `${this.path}/AddNotificacaoEmail`,
      data,
      {},
      true
    );
  }
}